import React from 'react'
import { cn } from 'utils'

const SectionHeader = ({
  children,
  className
}: {
  children: React.ReactNode
  className?: string
}) => {
  return (
    <h2
      className={cn(
        'text-5xl sm:text-7xl text-center font-semibold',
        className
      )}>
      {children}
    </h2>
  )
}

export default SectionHeader
